import Vue from 'vue'
import api from '@/api_alv'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'
import alvPlugin from '@/assets/helpers/alvPlugin'

const DIR = "az/groups"
const DEFAULT_AZ_GROUPS = {
    "id": 0,
    // column 1
    "group": null, // the name of the group
    "nameKatakana": null,
    "addressRow1": null,
    "addressRow2": null,
    "zip": null,
    "city": null,
    "state": null,
    "country": null,
    "fullShippingAddress": null,
    // column 2
    "alvId": "ALV000000000AG",
    "web": null,
    "facebook": null,
    "twitter": null,
    "youtube": null,
    "tags": null,
    "shippingNote": null,
    // column 3
    "phone": null,
    "fax": null,
    "cellphone": null,
    "email": null,
    "formatNameAddress": null,
    "notes": null,
    // column 4
    "gemaName": null,
    "type": null,
    "visibility": 2,

    "metadata": {
        // column 1
        "language": "de",
        "foundingDate": null,
        "customerNumber": null,
        "currency": null,
        // column 2
        "labelCompanyAlvId": null,
        "labelcode": null,
        "tonisNextPrefix": null,
        "tonisNextSuffix": null,
        "tasFromPricelist": null,
        "warehouseName": null,
        "focFirstShipment": null,
        "focAllShipments": null,
        "handlingFee": null,
        // column 3
        "publishingCompanyAlvId": null,
        "ipi": null,
        "gemaMember": "no",
        "bgNineSplit": "no",
        "ykto": null,
        "hkto": null,
        "ukto": null,
        "subSplitTreshold": null,
        "publishingStatementsDetailsMappingId": null,
        "publishingStatementsSummaryMappingId": null,
        "publishingStatementsPerWorkMappingId": null,
        "publishingStatementsProjectsSheetsMappingId": null,
        "publishingStatementsTop10MappingId": null,
        "publishingStatementsPayeeMappingId": null,
        "labelStatementsDigitalMappingId": null,
        "labelStatementsRetailMappingId": null,
        "labelStatementsLicenseMappingId": null,
        "labelStatementsPerReleaseMappingId": null,
    },

    "finance": {
        "accountHolder": null,
        "bankName": null,
        "bankDataLocalized": null,
        "bic": null,
        "iban": null,
        "labelStatementsText": null,
        "paymentOrder": null,
        "paymentTarget": null,
        "publishingStatementsText": null,
        "recoupmentPriority": "advancesFirst",
        "registerCourt": null,
        "registrationNumber": null,
        "taxIdNumber": null,
        "taxLiabilityPercentage": null,
        "taxWithholdingPercentage": null,
        "taxWithholdingSurchargePercentage": null,
        "taxNumber": null,
        "taxOffice": null,
        "taxWaiver": null,
        "taxWaiverFrom": null,
        "taxWaiverTo": null,
        "vatId": null,
        "vatLicense": null,
        "vatRetail": null
    },
    "persons": []
}

const DEFAULT_OTHER_IDS = {
    id: 0,
    value: null,
    name: null,
    personObject: null,
    type: 'recipientId',
    source: null,
    alvId: null,
    sourceAlvId: null,
    slgContractId: null,
    slgSubcatalogId: null,
}

const state = {
    // List
    groups: [],
    selectedAzGroups: [],
    isAllSelectedAzGroups: false,

    // Filters
    azGroupsSearch: "",
    selectedAzGroupsVisibilityFilter: ['visible', 'hidden'],
    
    // Actions
    selectedAzGroupsAction: [],
    // Assign mappings all results flag
    assignAllAzGroups: false,
    // Assign mappings result link
    assignMappingsResultLink: null,
    // Assign templates (bulk)
    showAzGroupsAssignTemplatesDialog: false,
    azGroupsAssignTemplates: {
        publishingDetailsMapping: null,
        publishingSummaryMapping: null,
        publishingPerWorkMapping: null,
        publishingProjectsSheetsMapping: null,
        publishingTop10Mapping: null,
    },

    // Details
    defaultNewAzGroups: DEFAULT_AZ_GROUPS,
    azGroupsUniqueId:   '',
    azGroupsDetails:    DEFAULT_AZ_GROUPS,
    expandedAzGroups:   [],
    azGroupsMetadata:   {},
    azGroupsFinance:    {},

    // Other IDs panel
    azGroupsOtherIds: [],
    // Selected AZ Group Other IDs
    selectedAzGroupOtherIds: [],
    // Other IDs editing dialog
    showAzGroupsOtherIdsEditingDialog: false,
    azGroupsOtherIdsEditingDialogDetails: DEFAULT_OTHER_IDS,
    defaultAzGroupsOtherIds: DEFAULT_OTHER_IDS,
    azGroupsOtherIdsEditingDialogPersonObjectOptions: [],
}

const getters = {
    // List
    getAzGroups(state)                                          { return state.groups },
    getSelectedAzGroups(state)                                  { return state.selectedAzGroups },
    getIsAllSelectedAzGroups(state)                             { return state.isAllSelectedAzGroups },
    getExpandedAzGroups(state)                                  { return state.expandedAzGroups },

    // Filters
    getAzGroupsSearch(state)                                    { return state.azGroupsSearch },
    getSelectedAzGroupsVisibilityFilter(state)                  { return state.selectedAzGroupsVisibilityFilter },

    // Actions
    getSelectedAzGroupsAction(state)                            { return state.selectedAzGroupsAction },
    getShowAzGroupsAssignTemplatesDialog(state)                 { return state.showAzGroupsAssignTemplatesDialog },
    // Assign Templates dialog values
    getAzGroupsAssignTemplates(state)                           { return state.azGroupsAssignTemplates },
    getAzGroupsAssignTemplatesDetailsPublishingDetailsMapping(state) { return state.azGroupsAssignTemplates.publishingDetailsMapping },
    getAzGroupsAssignTemplatesDetailsPublishingSummaryMapping(state) { return state.azGroupsAssignTemplates.publishingSummaryMapping },
    getAzGroupsAssignTemplatesDetailsPublishingPerWorkMapping(state) { return state.azGroupsAssignTemplates.publishingPerWorkMapping },
    getAzGroupsAssignTemplatesDetailsPublishingProjectsSheetsMapping(state) { return state.azGroupsAssignTemplates.publishingProjectsSheetsMapping },
    getAzGroupsAssignTemplatesDetailsPublishingTop10Mapping(state) { return state.azGroupsAssignTemplates.publishingTop10Mapping },
    getAzGroupsAssignMappingsResultLink(state) { return state.assignMappingsResultLink },

    // Details
    getDefaultNewAzGroups(state)                                { return state.defaultNewAzGroups },
    getAzGroupsUniqueId(state)                                  { return state.azGroupsUniqueId },
    getAzGroupsDetails(state)                                   { return state.azGroupsDetails },

    // Details: Column 1
    getAzGroupsDetailsGroup(state)                              { return state.azGroupsDetails.group },
    getAzGroupsDetailsNameKatakana(state)                       { return state.azGroupsDetails.nameKatakana },
    getAzGroupsDetailsAddressRowOne(state)                      { return state.azGroupsDetails.addressRow1 },
    getAzGroupsDetailsAddressRowTwo(state)                      { return state.azGroupsDetails.addressRow2 },
    getAzGroupsDetailsZip(state)                                { return state.azGroupsDetails.zip },
    getAzGroupsDetailsCity(state)                               { return state.azGroupsDetails.city },
    getAzGroupsDetailsState(state)                              { return state.azGroupsDetails.state },
    getAzGroupsDetailsCountry(state)                            { return state.azGroupsDetails.country },
    getAzGroupsDetailsFullShippingAddress(state)                { return state.azGroupsDetails.fullShippingAddress },

    // Details: column 2
    getAzGroupsDetailsAlvId(state)                              { return state.azGroupsDetails.alvId },
    getAzGroupsDetailsWeb(state)                                { return state.azGroupsDetails.web },
    getAzGroupsDetailsFacebook(state)                           { return state.azGroupsDetails.facebook },
    getAzGroupsDetailsTwitter(state)                            { return state.azGroupsDetails.twitter },
    getAzGroupsDetailsYoutube(state)                            { return state.azGroupsDetails.youtube },
    getAzGroupsDetailsTags(state)                               { return state.azGroupsDetails.tags },
    getAzGroupsDetailsShippingNote(state)                       { return state.azGroupsDetails.shippingNote },

    // Details: column 3
    getAzGroupsDetailsPhone(state)                              { return state.azGroupsDetails.phone },
    getAzGroupsDetailsFax(state)                                { return state.azGroupsDetails.fax },
    getAzGroupsDetailsCellphone(state)                          { return state.azGroupsDetails.cellphone },
    getAzGroupsDetailsEmail(state)                              { return state.azGroupsDetails.email },
    getAzGroupsDetailsFormatNameAddress(state)                  { return state.azGroupsDetails.formatNameAddress },
    getAzGroupsDetailsNotes(state)                              { return state.azGroupsDetails.notes },

    // Details: column 4
    getAzGroupsDetailsGemaName(state)                           { return state.azGroupsDetails.gemaName },
    getAzGroupsDetailsType(state)                               { return state.azGroupsDetails.type },
    getAzGroupsDetailsVisibility(state)                         { return state.azGroupsDetails.visibility },

    // Metadata Panel
    getAzGroupsMetadata(state)                                  { return state.azGroupsMetadata },

    // Metadata: Column 1
    getAzGroupsMetadataDetailsLanguage(state)                   { return state.azGroupsMetadata.language },
    getAzGroupsMetadataDetailsFoundingDate(state)               { return state.azGroupsMetadata.foundingDate },
    getAzGroupsMetadataDetailsCustomerNumber(state)             { return state.azGroupsMetadata.customerNumber },
    getAzGroupsMetadataDetailsCurrency(state)                   { return state.azGroupsMetadata.currency },
    getAzGroupsMetadataDetailsPublishingDetailsMapping(state)  { return state.azGroupsMetadata.publishingStatementsDetailsMappingId },
    getAzGroupsMetadataDetailsPublishingSummaryMapping(state)  { return state.azGroupsMetadata.publishingStatementsSummaryMappingId },
    getAzGroupsMetadataDetailsPublishingPerWorkMapping(state)   { return state.azGroupsMetadata.publishingStatementsPerWorkMappingId },
    getAzGroupsMetadataDetailsPublishingProjectsSheetsMapping(state)   { return state.azGroupsMetadata.publishingStatementsProjectsSheetsMappingId },
    getAzGroupsMetadataDetailsPublishingTop10Mapping(state)     { return state.azGroupsMetadata.publishingStatementsTop10MappingId },
    getAzGroupsMetadataDetailsPublishingPayeeMapping(state)     { return state.azGroupsMetadata.publishingStatementsPayeeMappingId },
    getAzGroupsMetadataDetailsLabelDigitalMapping(state)        { return state.azGroupsMetadata.labelStatementsDigitalMappingId },
    getAzGroupsMetadataDetailsLabelRetailMapping(state)         { return state.azGroupsMetadata.labelStatementsRetailMappingId },
    getAzGroupsMetadataDetailsLabelLicenseMapping(state)        { return state.azGroupsMetadata.labelStatementsLicenseMappingId },
    getAzGroupsMetadataDetailsLabelPerReleaseMapping(state)        { return state.azGroupsMetadata.labelStatementsPerReleaseMappingId },

    // Metadata: Column 2
    getAzGroupsMetadataDetailsLabelCompany(state)               { return state.azGroupsMetadata.labelCompanyAlvId },
    getAzGroupsMetadataDetailsLabelcode(state)                  { return state.azGroupsMetadata.labelcode },
    getAzGroupsMetadataDetailsTonisNextPrefix(state)            { return state.azGroupsMetadata.tonisNextPrefix },
    getAzGroupsMetadataDetailsTonisNextSuffix(state)            { return state.azGroupsMetadata.tonisNextSuffix },
    getAzGroupsMetadataDetailsTasFromPricelist(state)           { return state.azGroupsMetadata.tasFromPricelist },
    getAzGroupsMetadataDetailsWarehouseName(state)              { return state.azGroupsMetadata.warehouseName },
    getAzGroupsMetadataDetailsFocFirstShipment(state)           { return state.azGroupsMetadata.focFirstShipment },
    getAzGroupsMetadataDetailsFocAllShipments(state)            { return state.azGroupsMetadata.focAllShipments },
    getAzGroupsMetadataDetailsHandlingFee(state)                { return state.azGroupsMetadata.handlingFee },

    // Metadata: Column 3
    getAzGroupsMetadataDetailsPublishingCompany(state)          { return state.azGroupsMetadata.publishingCompanyAlvId },
    getAzGroupsMetadataDetailsIpi(state)                        { return state.azGroupsMetadata.ipi },
    getAzGroupsMetadataDetailsGemaMember(state)                 { return state.azGroupsMetadata.gemaMember },
    getAzGroupsMetadataDetailsBgNineSplit(state)                { return state.azGroupsMetadata.bgNineSplit },
    getAzGroupsMetadataDetailsYkto(state)                       { return state.azGroupsMetadata.ykto },
    getAzGroupsMetadataDetailsHkto(state)                       { return state.azGroupsMetadata.hkto },
    getAzGroupsMetadataDetailsUkto(state)                       { return state.azGroupsMetadata.ukto },
    getAzGroupsMetadataDetailsSubSplitTreshold(state)           { return state.azGroupsMetadata.subSplitTreshold },
    
    // Finance Panel
    getAzGroupsFinance(state)                                   { return state.azGroupsFinance },
    getAzGroupsFinanceDetailsPaymentOrder(state)                { return state.azGroupsFinance.paymentOrder },
    getAzGroupsFinanceDetailsAccountHolder(state)               { return state.azGroupsFinance.accountHolder },
    getAzGroupsFinanceDetailsPaymentTarget(state)               { return state.azGroupsFinance.paymentTarget },
    getAzGroupsFinanceDetailsVatId(state)                       { return state.azGroupsFinance.vatId },
    getAzGroupsFinanceDetailsIban(state)                        { return state.azGroupsFinance.iban },
    getAzGroupsFinanceDetailsAccountNumber(state)               { return state.azGroupsFinance.accountNumber },
    getAzGroupsFinanceDetailsVatRetail(state)                   { return state.azGroupsFinance.vatRetail },
    getAzGroupsFinanceDetailsVatLicense(state)                  { return state.azGroupsFinance.vatLicense },
    getAzGroupsFinanceDetailsTaxOffice(state)                   { return state.azGroupsFinance.taxOffice },
    getAzGroupsFinanceDetailsBic(state)                         { return state.azGroupsFinance.bic },
    getAzGroupsFinanceDetailsRegistrationNumber(state)          { return state.azGroupsFinance.registrationNumber },
    getAzGroupsFinanceDetailsTaxIdNumber(state)                 { return state.azGroupsFinance.taxIdNumber },
    getAzGroupsFinanceDetailsBankName(state)                    { return state.azGroupsFinance.bankName },
    getAzGroupsFinanceDetailsBankDataLocalized(state)          { return state.azGroupsFinance.bankDataLocalized },
    getAzGroupsFinanceDetailsRegisterCourt(state)               { return state.azGroupsFinance.registerCourt },
    getAzGroupsFinanceDetailsTaxNumber(state)                   { return state.azGroupsFinance.taxNumber },
    getAzGroupsFinanceDetailsTaxWaiver(state)                   { return state.azGroupsFinance.taxWaiver },
    getAzGroupsFinanceDetailsTaxWaiverFrom(state)               { return state.azGroupsFinance.taxWaiverFrom },
    getAzGroupsFinanceDetailsTaxWaiverTo(state)                 { return state.azGroupsFinance.taxWaiverTo },
    getAzGroupsFinanceDetailsTaxLiabilityPercentage(state)      { return state.azGroupsFinance.taxLiabilityPercentage },
    getAzGroupsFinanceDetailsTaxWithholdingPercentage(state)    { return state.azGroupsFinance.taxWithholdingPercentage },
    getAzGroupsFinanceDetailsTaxWithholdingSurchargePercentage(state)    { return state.azGroupsFinance.taxWithholdingSurchargePercentage },
    getAzGroupsFinanceDetailsRecoupmentPriority(state)          { return state.azGroupsFinance.recoupmentPriority },
    getAzGroupsFinanceDetailsPublishingStatementsText(state)    { return state.azGroupsFinance.publishingStatementsText },
    getAzGroupsFinanceDetailsLabelStatementsText(state)         { return state.azGroupsFinance.labelStatementsText },
    getAzGroupsImageUrl(state)                                  { return state.azGroupsDetails.picture },   

    // Other IDs panel and editing dialog
    getAzGroupsOtherIds                     (state) { return state.azGroupsOtherIds },
    getDefaultAzGroupsOtherIds              (state) { return state.defaultAzGroupsOtherIds },
    getAzGroupsOtherIdsEditingDialogDetails (state) { return state.azGroupsOtherIdsEditingDialogDetails },
    getSelectedAzGroupsOtherIds             (state) { return state.selectedAzGroupOtherIds },
    getShowAzGroupsOtherIdsEditingDialog    (state) { return state.showAzGroupsOtherIdsEditingDialog },
    getAzGroupsOtherIdsPersonObjectOptions  (state) { return state.azGroupsOtherIdsEditingDialogPersonObjectOptions },
    getAzGroupsOtherIdsDetailsPersonObject  (state) { return state.azGroupsOtherIdsEditingDialogDetails.personObject },
    getAzGroupsOtherIdsDetailsName          (state) { return state.azGroupsOtherIdsEditingDialogDetails.name },
    getAzGroupsOtherIdsDetailsAlvId         (state) { return state.azGroupsOtherIdsEditingDialogDetails.alvId },
    getAzGroupsOtherIdsDetailsType          (state) { return state.azGroupsOtherIdsEditingDialogDetails.type },
    getAzGroupsOtherIdsDetailsSource        (state) { return state.azGroupsOtherIdsEditingDialogDetails.source },
    getAzGroupsOtherIdsDetailsValue         (state) { return state.azGroupsOtherIdsEditingDialogDetails.value },
    getAzGroupsOtherIdsDetailsSourceAlvId   (state) { return state.azGroupsOtherIdsEditingDialogDetails.sourceAlvId },
    getAzGroupsOtherIdsDetailsSlgContractId (state) { return state.azGroupsOtherIdsEditingDialogDetails.slgContractId },
    getAzGroupsOtherIdsDetailsSlgSubcatalogId (state) { return state.azGroupsOtherIdsEditingDialogDetails.slgSubcatalogId },
}

const mutations = { 
    // List
    setAzGroups:                                    (state, item)   => { state.groups = item },
    setSelectedAzGroups:                            (state, item)   => { state.selectedAzGroups = item },
    setIsAllSelectedAzGroups:                       (state, item)   => { state.isAllSelectedAzGroups = item },
    setExpandedAzGroups:                            (state, item)   => { state.expandedAzGroups = [item] },

    // Filters
    setAzGroupsSearch:                              (state, item)   => { state.azGroupsSearch = item },
    setSelectedAzGroupsVisibilityFilter:            (state, item)   => { state.selectedAzGroupsVisibilityFilter = item },

    // Actions
    setSelectedAzGroupsAction:                      (state, item)   => { state.selectedAzGroupsAction = item },
    setAssignAllAzGroups:                           (state, value)  => { state.assignAllAzGroups = value },
    setAzGroupsAssignMappingsResultLink:            (state, value)  => { state.assignMappingsResultLink = value },
    setShowAzGroupsAssignTemplatesDialog:           (state, show)   => { state.showAzGroupsAssignTemplatesDialog = show },
    setAzGroupsAssignTemplates:                     (state, value)  => { state.azGroupsAssignTemplates = value },
    setAzGroupsAssignTemplatesDetailsPublishingDetailsMapping: (state, value) => { state.azGroupsAssignTemplates.publishingDetailsMapping = value },
    setAzGroupsAssignTemplatesDetailsPublishingSummaryMapping: (state, value) => { state.azGroupsAssignTemplates.publishingSummaryMapping = value },
    setAzGroupsAssignTemplatesDetailsPublishingPerWorkMapping: (state, value) => { state.azGroupsAssignTemplates.publishingPerWorkMapping = value },
    setAzGroupsAssignTemplatesDetailsPublishingProjectsSheetsMapping: (state, value) => { state.azGroupsAssignTemplates.publishingProjectsSheetsMapping = value },
    setAzGroupsAssignTemplatesDetailsPublishingTop10Mapping: (state, value) => { state.azGroupsAssignTemplates.publishingTop10Mapping = value },

    // Details
    setDefaultNewAzGroups:                          (state)         => { state.defaultNewAzGroups = DEFAULT_AZ_GROUPS },
    setAzGroupsUniqueId:                            (state, item)   => { state.azGroupsUniqueId = item },
    setAzGroupsDetails:                             (state, item)   => { state.azGroupsDetails = item },

    // Details: column 1
    setAzGroupsDetailsGroup:                        (state, item)   => { state.azGroupsDetails.group = item },
    setAzGroupsDetailsNameKatakana:                 (state, item)   => { state.azGroupsDetails.nameKatakana = item },
    setAzGroupsDetailsAddressRowOne:                (state, item)   => { state.azGroupsDetails.addressRow1 = item },
    setAzGroupsDetailsAddressRowTwo:                (state, item)   => { state.azGroupsDetails.addressRow2 = item },
    setAzGroupsDetailsZip:                          (state, item)   => { state.azGroupsDetails.zip = item },
    setAzGroupsDetailsCity:                         (state, item)   => { state.azGroupsDetails.city = item },
    setAzGroupsDetailsState:                        (state, item)   => { state.azGroupsDetails.state = item },
    setAzGroupsDetailsCountry:                      (state, item)   => { state.azGroupsDetails.country = item },
    setAzGroupsDetailsFullShippingAddress:          (state, item)   => { state.azGroupsDetails.fullShippingAddress = item },

    // Details: column 2
    setAzGroupsDetailsAlvId:                        (state, item)   => { state.azGroupsDetails.alvId = item },
    setAzGroupsDetailsWeb:                          (state, item)   => { state.azGroupsDetails.web = item },
    setAzGroupsDetailsFacebook:                     (state, item)   => { state.azGroupsDetails.facebook = item },
    setAzGroupsDetailsTwitter:                      (state, item)   => { state.azGroupsDetails.twitter = item },
    setAzGroupsDetailsYoutube:                      (state, item)   => { state.azGroupsDetails.youtube = item },
    setAzGroupsDetailsTags:                         (state, item)   => { state.azGroupsDetails.tags = item },
    setAzGroupsDetailsShippingNote:                 (state, item)   => { state.azGroupsDetails.shippingNote = item },

    // Details: column 3
    setAzGroupsDetailsPhone:                        (state, item)   => { state.azGroupsDetails.phone = item },
    setAzGroupsDetailsFax:                          (state, item)   => { state.azGroupsDetails.fax = item },
    setAzGroupsDetailsCellphone:                    (state, item)   => { state.azGroupsDetails.cellphone = item },
    setAzGroupsDetailsEmail:                        (state, item)   => { state.azGroupsDetails.email = item },
    setAzGroupsDetailsFormatNameAddress:            (state, item)   => { state.azGroupsDetails.formatNameAddress = item },
    setAzGroupsDetailsNotes:                        (state, item)   => { state.azGroupsDetails.notes = item },

    // Details: column 4
    setAzGroupsDetailsGemaName:                     (state, item)   => { state.azGroupsDetails.gemaName = item },
    setAzGroupsDetailsType:                         (state, item)   => { state.azGroupsDetails.type = item },
    setAzGroupsDetailsVisibility:                   (state, item)   => { state.azGroupsDetails.visibility = item },

    // Metadata Panel
    setAzGroupsMetadata:                            (state, item)   => { state.azGroupsMetadata = item },

    // Metadata: Column 1
    setAzGroupsMetadataDetailsLanguage:             (state, item)   => { state.azGroupsMetadata.language = item },    
    setAzGroupsMetadataDetailsFoundingDate:         (state, item)   => { state.azGroupsMetadata.foundingDate = item },
    setAzGroupsMetadataDetailsCustomerNumber:       (state, item)   => { state.azGroupsMetadata.customerNumber = item },
    setAzGroupsMetadataDetailsCurrency:             (state, item)   => { state.azGroupsMetadata.currency = item },
    setAzGroupsMetadataDetailsPublishingDetailsMapping:(state, value) => { state.azGroupsMetadata.publishingStatementsDetailsMappingId = value },
    setAzGroupsMetadataDetailsPublishingSummaryMapping:(state, value) => { state.azGroupsMetadata.publishingStatementsSummaryMappingId = value },
    setAzGroupsMetadataDetailsPublishingPerWorkMapping:(state, value) => { state.azGroupsMetadata.publishingStatementsPerWorkMappingId = value },
    setAzGroupsMetadataDetailsPublishingProjectsSheetsMapping:(state, value) => { state.azGroupsMetadata.publishingStatementsProjectsSheetsMappingId = value },
    setAzGroupsMetadataDetailsPublishingTop10Mapping:(state, value) => { state.azGroupsMetadata.publishingStatementsTop10MappingId = value },
    setAzGroupsMetadataDetailsPublishingPayeeMapping:(state, value) => { state.azGroupsMetadata.publishingStatementsPayeeMappingId = value },
    setAzGroupsMetadataDetailsLabelDigitalMapping:   (state, value) => { state.azGroupsMetadata.labelStatementsDigitalMappingId = value },
    setAzGroupsMetadataDetailsLabelRetailMapping:    (state, value) => { state.azGroupsMetadata.labelStatementsRetailMappingId = value },
    setAzGroupsMetadataDetailsLabelLicenseMapping:   (state, value) => { state.azGroupsMetadata.labelStatementsLicenseMappingId = value },
    setAzGroupsMetadataDetailsLabelPerReleaseMapping:   (state, value) => { state.azGroupsMetadata.labelStatementsPerReleaseMappingId = value },

    // Metadata: Column 2
    setAzGroupsMetadataDetailsLabelCompany:         (state, item)   => { state.azGroupsMetadata.labelCompanyAlvId = item },
    setAzGroupsMetadataDetailsLabelcode:            (state, item)   => { state.azGroupsMetadata.labelcode = item },
    setAzGroupsMetadataDetailsTonisNextPrefix:      (state, item)   => { state.azGroupsMetadata.tonisNextPrefix = item },
    setAzGroupsMetadataDetailsTonisNextSuffix:      (state, item)   => { state.azGroupsMetadata.tonisNextSuffix = item },
    setAzGroupsMetadataDetailsTasFromPricelist:     (state, item)   => { state.azGroupsMetadata.tasFromPricelist = item },
    setAzGroupsMetadataDetailsWarehouseName:        (state, item)   => { state.azGroupsMetadata.warehouseName = item },
    setAzGroupsMetadataDetailsFocFirstShipment:     (state, item)   => { state.azGroupsMetadata.focFirstShipment = item },
    setAzGroupsMetadataDetailsFocAllShipments:      (state, item)   => { state.azGroupsMetadata.focAllShipments = item },
    setAzGroupsMetadataDetailsHandlingFee:          (state, item)   => { state.azGroupsMetadata.handlingFee = item },

    // Metadata: Column 3
    setAzGroupsMetadataDetailsPublishingCompany:    (state, item)   => { state.azGroupsMetadata.publishingCompanyAlvId = item },
    setAzGroupsMetadataDetailsIpi:                  (state, item)   => { state.azGroupsMetadata.ipi = item },
    setAzGroupsMetadataDetailsGemaMember:           (state, item)   => { state.azGroupsMetadata.gemaMember = item },
    setAzGroupsMetadataDetailsBgNineSplit:          (state, item)   => { state.azGroupsMetadata.bgNineSplit = item },
    setAzGroupsMetadataDetailsYkto:                 (state, item)   => { state.azGroupsMetadata.ykto = item },
    setAzGroupsMetadataDetailsHkto:                 (state, item)   => { state.azGroupsMetadata.hkto = item },
    setAzGroupsMetadataDetailsUkto:                 (state, item)   => { state.azGroupsMetadata.ukto = item },
    setAzGroupsMetadataDetailsSubSplitTreshold:     (state, item)   => { state.azGroupsMetadata.subSplitTreshold = item },
    
    // Finance Panel
    setAzGroupsFinance:                             (state, item)   => { state.azGroupsFinance = item },
    setAzGroupsFinanceDetailsPaymentOrder:          (state, item)   => { state.azGroupsFinance.paymentOrder = item },
    setAzGroupsFinanceDetailsAccountHolder:         (state, item)   => { state.azGroupsFinance.accountHolder = item },
    setAzGroupsFinanceDetailsPaymentTarget:         (state, item)   => { state.azGroupsFinance.paymentTarget = item },
    setAzGroupsFinanceDetailsVatId:                 (state, item)   => { state.azGroupsFinance.vatId = item },
    setAzGroupsFinanceDetailsIban:                  (state, item)   => { state.azGroupsFinance.iban = item },
    setAzGroupsFinanceDetailsVatRetail:             (state, item)   => { state.azGroupsFinance.vatRetail = item },
    setAzGroupsFinanceDetailsVatLicense:            (state, item)   => { state.azGroupsFinance.vatLicense = item },
    setAzGroupsFinanceDetailsTaxOffice:             (state, item)   => { state.azGroupsFinance.taxOffice = item },
    setAzGroupsFinanceDetailsBic:                   (state, item)   => { state.azGroupsFinance.bic = item },
    setAzGroupsFinanceDetailsRegistrationNumber:    (state, item)   => { state.azGroupsFinance.registrationNumber = item },
    setAzGroupsFinanceDetailsTaxIdNumber:           (state, item)   => { state.azGroupsFinance.taxIdNumber = item },
    setAzGroupsFinanceDetailsBankName:              (state, item)   => { state.azGroupsFinance.bankName = item },
    setAzGroupsFinanceDetailsBankDataLocalized:     (state, item)   => { state.azGroupsFinance.bankDataLocalized = item },
    setAzGroupsFinanceDetailsRegisterCourt:         (state, item)   => { state.azGroupsFinance.registerCourt = item },
    setAzGroupsFinanceDetailsTaxNumber:             (state, item)   => { state.azGroupsFinance.taxNumber = item },
    setAzGroupsFinanceDetailsTaxWaiver:             (state, item)   => { state.azGroupsFinance.taxWaiver = item },
    setAzGroupsFinanceDetailsTaxWaiverFrom:         (state, item)   => { state.azGroupsFinance.taxWaiverFrom = item },
    setAzGroupsFinanceDetailsTaxWaiverTo:           (state, item)   => { state.azGroupsFinance.taxWaiverTo = item },
    setAzGroupsFinanceDetailsTaxLiabilityPercentage:(state, item)   => { state.azGroupsFinance.taxLiabilityPercentage = item },
    setAzGroupsFinanceDetailsTaxWithholdingPercentage:(state, item) => { state.azGroupsFinance.taxWithholdingPercentage = item },
    setAzGroupsFinanceDetailsTaxWithholdingSurchargePercentage:(state, item) => { state.azGroupsFinance.taxWithholdingSurchargePercentage = item },
    setAzGroupsFinanceDetailsRecoupmentPriority:    (state, item)   => { state.azGroupsFinance.recoupmentPriority = item },
    setAzGroupsFinanceDetailsPublishingStatementsText:(state, item) => { state.azGroupsFinance.publishingStatementsText = item },
    setAzGroupsFinanceDetailsLabelStatementsText:   (state, item)   => { state.azGroupsFinance.labelStatementsText = item },
     //ImageUploader
     setAzGroupsImageUrl:                           (state, item)   => { state.azGroupsDetails.picture = item },

    // Other IDs panel and editing dialog
    setAzGroupsOtherIds:                        (state, value) => { state.azGroupsOtherIds = value },
    setDefaultAzGroupsOtherIds:                 (state, value) => { state.defaultAzGroupsOtherIds = value },
    setAzGroupsOtherIdsEditingDialogDetails:    (state, value) => { state.azGroupsOtherIdsEditingDialogDetails = value },
    setSelectedAzGroupsOtherIds:                (state, value) => { state.selectedAzGroupOtherIds = value },
    setShowAzGroupsOtherIdsEditingDialog:       (state, value) => { state.showAzGroupsOtherIdsEditingDialog = value },
    setAzGroupsOtherIdsPersonObjectOptions:     (state, value) => { state.azGroupsOtherIdsEditingDialogPersonObjectOptions = value },
    setAzGroupsOtherIdsDetailsPersonObject:     (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.personObject = value },
    setAzGroupsOtherIdsDetailsName:             (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.name = value },
    setAzGroupsOtherIdsDetailsAlvId:            (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.alvId = value },
    setAzGroupsOtherIdsDetailsType:             (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.type = value },
    setAzGroupsOtherIdsDetailsSource:           (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.source = value },
    setAzGroupsOtherIdsDetailsValue:            (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.value = value },
    setAzGroupsOtherIdsDetailsSourceAlvId:      (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.sourceAlvId = value },
    setAzGroupsOtherIdsDetailsSlgContractId:    (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.slgContractId = value },
    setAzGroupsOtherIdsDetailsSlgSubcatalogId:  (state, value) => { state.azGroupsOtherIdsEditingDialogDetails.slgSubcatalogId = value },
}

const actions = {
// FETCH LIST
    async fetchAzGroups( { commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search' : getters.getAzGroupsSearch,
            'visibility': getters.getSelectedAzGroupsVisibilityFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setAzGroups', [])
        } else {
            commit('setAzGroups', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

    // DETAILS (read-only)
    async fetchAzGroupsDetails({ commit, getters, dispatch }, alvId) {
        let values
        let currentPage = router.currentRoute.name

        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewAzGroups)) 
            // let country = this._vm.$alvPlugin.setCountryInAzGroupsAndPersons()

            // As we only support two languages for A-Z we have to check the account language,
            // to find out if we will set 'de' or 'en' as A-Z language.
            let accountLanguage = getters.getUserLanguage
            defaultValues.metadata.language = accountLanguage === 'de' ? accountLanguage : 'en'
            // Country is not a required field anymore
            // defaultValues.country = country

            values = defaultValues
        }
        else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else {
                let shippingAddress = ""
                if (response.fullShippingAddress != null)
                    shippingAddress = response.fullShippingAddress
                if (currentPage == "AzGroupsEdit")
                    shippingAddress = shippingAddress.replace(/<br\s*[\/]?>/gi, "\n")
                response.fullShippingAddress = shippingAddress
                values = response
            }
        }
        commit('setAzGroupsDetails', values)
        dispatch('fetchAzGroupsMetadata')
        dispatch('fetchAzGroupsFinance')
        dispatch('fetchAzGroupsPersons')
        dispatch('fetchAzGroupsOtherIds')
        commit('setIsLoading', false)
    },

    // FETCH METADATA
    async fetchAzGroupsMetadata({ getters, commit }) {
        let metadataFromDB = getters.getAzGroupsDetails.metadata
        commit('setAzGroupsMetadata', metadataFromDB)
    },

    // FETCH FINANCE
    async fetchAzGroupsFinance({ getters, commit }) {
        let financeFromDB = getters.getAzGroupsDetails.finance
        if(financeFromDB){
            if(financeFromDB.vatLicense !== null && financeFromDB.vatLicense !== ''){
                financeFromDB.vatLicense = i18n.n(financeFromDB.vatLicense,'number')
            }
            if(financeFromDB.vatRetail !== null && financeFromDB.vatRetail !== ''){
                financeFromDB.vatRetail = i18n.n(financeFromDB.vatRetail,'number')
            }
        }
        commit('setAzGroupsFinance', financeFromDB)
    },

    // FETCH PERSONS
    async fetchAzGroupsPersons({ getters, commit }) {
        let personsFromDB = getters.getAzGroupsDetails.persons
        personsFromDB.forEach(row => {
            row['inheritFromGroup'] = row['inheritFromGroup'] === true ? 'yes' : 'no'
        });
        
        commit('setPersonsPanelEntry', personsFromDB)
    },
    // FETCH Other IDs
    async fetchAzGroupsOtherIds({ commit, getters }) {
        let otherIdsFromDb = getters.getAzGroupsDetails.otherIds

        if (otherIdsFromDb == undefined || otherIdsFromDb == null ) {
            otherIdsFromDb = []
        }

        commit('setAzGroupsOtherIds', otherIdsFromDb)
    },
    // Fetch AZ entries for Other IDs (Abrechnungsquelle): one row per A-Z entry (ALVCODE-1537)
    async fetchAutocompleteAzGroupsOtherIdsPersonObject( { commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setAzGroupsOtherIdsPersonObjectOptions', response.list)
    },
    // Delete from Other IDs
    deleteSelectedAzGroupsOtherIds( {commit, getters} ) {
        let id = getters.getSelectedAzGroupsOtherIds
        let index = state.azGroupsOtherIds.findIndex(cond => cond.id == id)

        let startOtherIdsAmount = getters.getAzGroupsOtherIds.length
        Vue.delete(state.azGroupsOtherIds, index)
        let newOtherIdsAmount = getters.getAzGroupsOtherIds.length
        commit('setSelectedAzGroupsOtherIds', [])

        if (startOtherIdsAmount > newOtherIdsAmount) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        }

        if (newOtherIdsAmount == 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    // Delete Person
    async deleteSelectedAzGroupsPersons({ dispatch }) {
        dispatch('deleteSelectedPersonsPanelEntry')
        this.$store.commit('setSelectedPersonsPanelEntry', [])
    },

    // SAVE
    async saveAzGroupsForm({ commit, getters, dispatch }, redirect = true) { // redirect attribute is used when the saving function is called from another page than AzGroupsEdit
        let alvId = getters.getAzGroupsDetailsAlvId
        let isNew = false
        
        if(!redirect) { isNew = getters.getAzGroupsDetails['id'] === 0 }
        else isNew = router.currentRoute.params.alvId == "new"

        // Payload
        getters.getPersonsPanelEntry.forEach(row => {
            row['inheritFromGroup'] =  row['inheritFromGroup'] === 'yes' ? true : false
        })
        getters.getAzGroupsDetails.persons = getters.getPersonsPanelEntry
        let azGroupDetails = { ...getters.getAzGroupsDetails } 
        let metaData = azGroupDetails.metadata

        // Instead of sending empty array, send null for currency
        if ((Array.isArray(metaData.currency) && metaData.currency.length === 0) || metaData.currency == "array") {
            azGroupDetails.metadata.currency = null;
        }

        let response = await api.saveEditForm(DIR, alvId, azGroupDetails, isNew)   

        if(response === undefined || response.length === 0 || response.error === 1) { 
            let errorMessages = response.response.errorMsg
            let errorMessageForSnackbar = i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL')

            errorMessages.forEach(msg => {
                errorMessageForSnackbar += '<br />' + i18n.t(msg)
            })

            commit('setSnackbar', {
                type: 'error',
                msg: errorMessageForSnackbar
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })
            
            // redirect for url now with ALVID
            if(isNew && redirect) router.push( { name: 'AzGroupsEdit', params: { alvId: response.response.alvId }} )

            // refresh data
            await dispatch('fetchAzGroupsDetails', response.response.alvId)
            this._vm.$alvPlugin.updateListOfDistributorsInLocalStorageAccordingToEntity(getters.getAzGroupsDetails)
        }
    },

    // ACTIONS Switch
    async doAzGroupsAction({ dispatch, commit }) {
        if(state.selectedAzGroupsAction === 'assignTemplates') {
            if(state.selectedAzGroups.length === 0){
                let r = await dispatch('runConfirmationDialog')
                if (r) {
                    commit('setAssignAllAzGroups', true)
                    commit('setShowAzGroupsAssignTemplatesDialog', true)
                }
            } else {
                commit('setAssignAllAzGroups', false)
                commit('setShowAzGroupsAssignTemplatesDialog', true)
            }
            return
        }
        if(state.selectedAzGroups.length > 0) {
            switch(state.selectedAzGroupsAction) {
                case 'delete':
                    commit('setShowDeletionDialog', true)
                    break
                case 'replaceTags':
                    commit('setShowManageTagsDialog', true)
                    break
                case 'printAzGroupsA6Labels' :
                    dispatch('createA6GroupsPDF')
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)
        }
    },

    // Assign mappings (frontend -> backend)
    async assignMappingsAzGroups({ getters, commit, state }, params = {}) {
        const DIR = 'az/groups'
        const queryParams = { action: 'assignMappings' }

        const mappings = {
            publishing_statements: {
                summary: getters.getAzGroupsAssignTemplatesDetailsPublishingSummaryMapping || null,
                details: getters.getAzGroupsAssignTemplatesDetailsPublishingDetailsMapping || null,
                perWork: getters.getAzGroupsAssignTemplatesDetailsPublishingPerWorkMapping || null,
                projectsSheets: getters.getAzGroupsAssignTemplatesDetailsPublishingProjectsSheetsMapping || null,
                top10: getters.getAzGroupsAssignTemplatesDetailsPublishingTop10Mapping || null,
            }
        }

        const metaData = { mappings }
        if (params && params.clearEmpty === true) {
            metaData.clearEmpty = true
        }
        if (state.assignAllAzGroups === false) {
            metaData['alvIds'] = getters.getSelectedAzGroups
        }

        const response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setAssignAllAzGroups', false)

        if (response && response.error === -1 && response.response && response.response.path) {
            commit('setAzGroupsAssignMappingsResultLink', response.response.path)
            // keep dialog open and show cloud icon
        } else if (response && response.response && response.response.errorMsg) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },

    // DELETE
    async deleteSelectedAzGroups({ commit, getters, dispatch }) {
        let response = await api.deleteEntries(DIR, getters.getSelectedAzGroups)

        if(response.error === -1) {
            for(let i = 0; i < getters.getSelectedAzGroups.length; i++) {
                let index = getters.getAzGroups.findIndex(person => person.alvId == getters.getSelectedAzGroups[i])
                Vue.delete(getters.getAzGroups, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            dispatch('fetchAzGroups')
        } else {
            commit('setErrorDialogCsvLink', response.response.path)
            commit('setErrorMessageCode', response.errorCode)
            commit('setShowErrorDialog', true)
        }

        commit('setSelectedAzGroups', [])
        commit('setSelectedAzGroupsAction', [])
        commit('setIsAllSelectedAzGroups', false)
    },

        // A6
    async createA6GroupsPDF({ getters, commit }) {
        document.body.style.cursor = 'wait';
        
        let queryParams = { "action": "printA6" }

        let metaData = {
            "alvIds"            : getters.getSelectedAzGroups ,
            "sendingCompany"    : getters.getSelectedLabelCompanyId
        }
        
        
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
        
        document.body.style.cursor = 'default';
    },

}

export default {
    state, getters, actions, mutations
}